import { render, staticRenderFns } from "./PtZoneDetails.vue?vue&type=template&id=72c88429&"
import script from "./PtZoneDetails.vue?vue&type=script&lang=js&"
export * from "./PtZoneDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports